import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import type { AppMeta } from "@/lib/apps";

interface AppCardProps {
  app: AppMeta;
}

const AppCard = ({ app }: AppCardProps) => {
  return (
    <Link
      to={app.href}
      className={`group relative overflow-hidden rounded-2xl border border-border bg-card p-8 shadow-card hover:shadow-elevated transition-shadow duration-500 ${app.themeClass}`}
    >
      {/* gradient glow accent */}
      <div className={`absolute -top-24 -right-24 h-56 w-56 rounded-full opacity-20 blur-3xl ${app.gradientClass} transition-opacity duration-500 group-hover:opacity-40`} aria-hidden />

      <div className="relative flex flex-col h-full min-h-[280px]">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="h-14 w-14 overflow-hidden rounded-xl border border-border bg-background shadow-sm">
              <img
                src={app.icon}
                alt=""
                aria-hidden
                className="h-full w-full object-contain p-1"
                loading="lazy"
              />
            </div>
            <span className="inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-emerald-600 dark:text-emerald-400">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 animate-pulse" />
              Live
            </span>
          </div>
          <ArrowUpRight className="h-5 w-5 text-muted-foreground group-hover:text-foreground group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
        </div>

        <div className="mt-8">
          <img
            src={app.logo}
            alt={`${app.name} logo`}
            className="h-10 w-auto object-contain"
            loading="lazy"
          />
        </div>

        <p className="mt-3 text-xs font-medium uppercase tracking-[0.18em] text-muted-foreground">
          {app.community}
        </p>

        <p className="mt-4 text-base leading-relaxed text-foreground/85">
          {app.description}
        </p>

        <p className="mt-auto pt-6 text-sm font-medium text-primary">
          {app.tagline}
        </p>
      </div>
    </Link>
  );
};

export default AppCard;
